import { BaseChart } from "./BaseChart";
import { TimePeriod } from "./TimePeriodSelector";
import type { RespiratoryRateResponse } from "@/types/tracker";
import { processSimpleTrackerChartData } from "./utils";
import { getMetricColor } from "./chart-theme";

interface RespiratoryRateChartProps {
  data: RespiratoryRateResponse | null;
  selectedPeriod: TimePeriod;
  currentDate: Date;
}

export const RespiratoryRateChart = ({
  data,
  selectedPeriod,
  currentDate,
}: RespiratoryRateChartProps) => {
  const yAxisConfig = data?.y_axis || { min: 10, max: 30 };
  const chartData = processSimpleTrackerChartData(
    data,
    selectedPeriod,
    currentDate
  );

  const range = yAxisConfig.max - yAxisConfig.min;
  let customInterval: number;

  if (range <= 10) {
    customInterval = 5;
  } else if (range <= 20) {
    customInterval = 5;
  } else if (range <= 30) {
    customInterval = 5;
  } else {
    customInterval = 10;
  }

  const customYAxisConfig = {
    ...yAxisConfig,
    customInterval,
  };

  return (
    <BaseChart
      data={chartData}
      selectedPeriod={selectedPeriod}
      currentDate={currentDate}
      yAxisConfig={customYAxisConfig}
      chartColor={getMetricColor("respiratory-rate")}
      metricName="Respiratory Rate"
      unit="BPM"
    />
  );
};
